class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.overlay = document.querySelector('.header-overlay');
    this.isMegaMenu = this.mainDetailsToggle?.classList.contains('mega-menu');
    this.hoverCloseTimeout = null;
    this.HOVER_CLOSE_DELAY_MS = 100;

    if (this.isMegaMenu && window.matchMedia('(hover: hover)').matches) {
      this.addEventListener('mouseenter', this.onMegaMenuMouseEnter.bind(this));
      this.addEventListener('mouseleave', this.onMegaMenuMouseLeave.bind(this));
    }

    this.closeButton = this.querySelector('.mega-menu__close-button');
    if (this.closeButton) {
      this.closeButton.addEventListener('click', this.onMegaMenuCloseClick.bind(this));
    }
  }

  onMegaMenuCloseClick(event) {
    event.preventDefault();
    this.close();
    this.mainDetailsToggle?.querySelector('summary')?.focus();
  }

  open() {
    if (!this.mainDetailsToggle) return;
    this.mainDetailsToggle.setAttribute('open', '');
    this.mainDetailsToggle.querySelector('summary')?.setAttribute('aria-expanded', 'true');
    if(this.overlay) {
      this.overlay.classList.remove('hidden');
    }
  }

  onMegaMenuMouseEnter() {
    if (this.hoverCloseTimeout) {
      clearTimeout(this.hoverCloseTimeout);
      this.hoverCloseTimeout = null;
    }
    this.open();
  }

  onMegaMenuMouseLeave() {
    this.hoverCloseTimeout = setTimeout(() => {
      this.close();
      this.hoverCloseTimeout = null;
      const activeMegamenu = document.querySelector('.mega-menu[open]');
      if(!activeMegamenu) {
        if(this.overlay) {
          this.overlay.classList.add('hidden');
        }
      }
    }, this.HOVER_CLOSE_DELAY_MS);
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
